import { Paper, Box, Typography } from '@mui/material';

const EmptyState = () => {
    return (
         <Paper
             elevation={0}
             sx={{
               position: "relative",
                height: "100%",
               display: "flex",
               flexDirection: "column",
             }}
           >
             <Box sx={{ m: "auto", textAlign: "center" }}>
               <Box
                 component={"img"}
                 sx={{ m: "auto", width: "20%", height: "auto" }}
                 src="/assets/logo-red-(512x110).png"
                 alt="logo"
               />
       
               <Typography variant="h5">Let's chat</Typography>
               <Typography variant="body2" color="textSecondary">
                 Select a chat to start messaging
               </Typography>
             </Box>
           </Paper>
    )
}

export default EmptyState;
